/**
 * Beacon analytics — appelé par les pages publiques (WallTunes + marketing).
 * Fire-and-forget : n'attend pas la réponse, ne bloque jamais le rendu.
 *
 * Utilise `sendBeacon` en priorité (survit à la navigation) et retombe sur
 * fetch/keepalive sinon.
 */
const API = process.env.REACT_APP_BACKEND_URL;

export function trackPageView(source) {
  if (!source || !API) return;
  const url = `${API}/api/analytics/beacon?source=${encodeURIComponent(source)}`;
  try {
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url);
      return;
    }
  } catch {
    // fall through to fetch
  }
  try {
    fetch(url, { method: "POST", keepalive: true }).catch(() => {});
  } catch {
    // silencieux : les analytics ne doivent jamais casser une page
  }
}
